module.exports = __webpack_public_path__ + "static/img/homeleft41.d84a6c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homeleft41.png
// module id = WPXz
// module chunks = 13